import { code } from "@spscommerce/utils";

export const SpsAdvancedSearchExamples = {
    basic: {
        label: "Basic Usage",
        examples: {
            basic: {
                template: code`
                    <sps-list-toolbar id="basic-list-toolbar" [advancedSearch]="advSearch">
                        <sps-list-toolbar-search (formSubmit)="onSimpleSearch()">
                            <sps-text-input
                                [(ngModel)]="simpleSearchValue"
                                placeholder="Type here to search for something"
                                [disabled]="advSearch.isOpen"
                            ></sps-text-input>
                            <sps-button type="submit" kind="icon" icon="search" [disabled]="advSearch.isOpen"></sps-button>
                        </sps-list-toolbar-search>
                        <sps-button-group>
                            <sps-button kind="link">Link Button</sps-button>
                            <sps-button kind="icon" icon="sort-alpha-asc"></sps-button>
                            <sps-button kind="icon" icon="list-table"></sps-button>
                            <sps-button kind="icon" icon="column-switcher"></sps-button>
                            <sps-button>Button</sps-button>
                        </sps-button-group>
                    </sps-list-toolbar>
                    <sps-advanced-search id="basic-advanced-search" #advSearch [formGroup]="form"
                        (submit)="onAdvSearchSubmit($event)"
                        (clear)="onAdvSearchClear()"
                        [isOpen]="true"
                        [defaults]="searchDefaults"
                    >
                        <div class="sps-row">
                            <div class="col-4">
                                <sps-label for="sender">Sender</sps-label>
                                <sps-text-input formControlName="sender" placeholder="Enter a sender name"></sps-text-input>
                            </div>
                            <div class="col-4">
                                <sps-label for="receiver">Receiver</sps-label>
                                <sps-text-input formControlName="receiver" placeholder="Enter a receiver name"></sps-text-input>
                            </div>
                            <div class="col-4">
                                <sps-label for="doctype">Document Type</sps-label>
                                <sps-text-input formControlName="doctype" placeholder="Enter a document type"></sps-text-input>
                            </div>
                            <div class="col-4">
                                <sps-label for="status">Status</sps-label>
                                <sps-text-input formControlName="status" placeholder="Enter a status"></sps-text-input>
                            </div>
                            <div class="col-4">
                                <sps-label for="archivedDocs">Archived Documents</sps-label>
                                <sps-input-group>
                                    <sps-radio-button value="exclude" label="Exclude" formControlName="archivedDocs"></sps-radio-button>
                                    <sps-radio-button value="include" label="Include" formControlName="archivedDocs"></sps-radio-button>
                                    <sps-radio-button value="only" label="Only" formControlName="archivedDocs"></sps-radio-button>
                                </sps-input-group>
                            </div>
                        </div>
                    </sps-advanced-search>
                `,
                class: code`
                    class DemoComponent {
                        simpleSearchValue = "";
                        form: FormGroup;
                        searchDefaults: any;

                        constructor(private formBuilder: FormBuilder) {}

                        ngOnInit() {
                            this.form = this.formBuilder.group({
                                sender: [""],
                                receiver: [""],
                                doctype: [""],
                                status: [""],
                                archivedDocs: ["exclude"]
                            });
                            this.searchDefaults = this.form.value;

                            // Alter the form from the init value to show the
                            // "changed fields" tag in the List Toolbar
                            this.form.patchValue({
                                receiver: "Walmart",
                                archivedDocs: "include"
                            });
                        }

                        onSimpleSearch(search) {
                            console.log("Simple search", this.simpleSearchValue);
                        }

                        onAdvSearchSubmit(search) {
                            console.log("Advanced search", search);
                        }

                        onAdvSearchClear() {
                            console.log("Advanced search form cleared");
                        }
                    }
                `
            }
        }
    },
    disabledButtons: {
        label: "Disabling the Clear/Search Buttons",
        examples: {
            disabledButtons: {
                template: code`
                    <sps-list-toolbar [advancedSearch]="advSearch">
                        <sps-list-toolbar-search>
                            <sps-text-input
                                [(ngModel)]="simpleSearchValue"
                                placeholder="Type here to search for something"
                                [disabled]="advSearch.isOpen"
                            ></sps-text-input>
                            <sps-button type="submit" kind="icon" icon="search" [disabled]="advSearch.isOpen"></sps-button>
                        </sps-list-toolbar-search>
                    </sps-list-toolbar>
                    <sps-advanced-search #advSearch
                        [formGroup]="form"
                        [isOpen]="true"
                        [controlsDisabled]="true"
                    >
                        <i>insert form here</i>
                    </sps-advanced-search>
                `,
                class: code`
                    class DemoComponent implements OnInit {
                        simpleSearchValue = "";
                        form: FormGroup;

                        constructor(private formBuilder: FormBuilder) {}

                        ngOnInit() {
                            this.form = this.formBuilder.group({});
                        }
                    }
                `
            }
        }
    },
    footerLink: {
        label: "Footer Link",
        description: code`
            <p>Some applications have a need to add a link button to the footer
            as directed by the product design team.</p>
        `,
        examples: {
            footerLink: {
                template: code`
                    <sps-list-toolbar [advancedSearch]="advSearch">
                        <sps-list-toolbar-search>
                            <sps-text-input
                                [(ngModel)]="simpleSearchValue"
                                placeholder="Type here to search for something"
                                [disabled]="advSearch.isOpen"
                            ></sps-text-input>
                            <sps-button type="submit" kind="icon" icon="search" [disabled]="advSearch.isOpen"></sps-button>
                        </sps-list-toolbar-search>
                    </sps-list-toolbar>
                    <sps-advanced-search #advSearch [formGroup]="form" [isOpen]="true">
                        <i>insert form here</i>
                        <sps-advanced-search-footer>
                            <sps-button kind="link" icon="gear">Advanced Search Defaults</sps-button>
                        </sps-advanced-search-footer>
                    </sps-advanced-search>
                `,
                class: code`
                    class DemoComponent implements OnInit {
                        simpleSearchValue = "";
                        form: FormGroup;

                        constructor(private formBuilder: FormBuilder) {}

                        ngOnInit() {
                            this.form = this.formBuilder.group({});
                        }
                    }
                `
            }
        }
    },
    withoutSimpleSearch: {
        label: "Title Bar With No List Toolbar Search",
        description: code`
            <p>If you do not provide a search within the List Toolbar, then it will
            act as a title bar and the Advanced Search will not be togglable.</p>
        `,
        examples: {
            withoutSimpleSearch: {
                template: code`
                    <sps-list-toolbar [advancedSearch]="advSearch"  title="Advanced Search"></sps-list-toolbar>
                    <sps-advanced-search #advSearch [formGroup]="form" [isOpen]="true">
                        <i>insert form here</i>
                    </sps-advanced-search>
                `,
                class: code`
                    class DemoComponent implements OnInit {
                        simpleSearchValue = "";
                        form: FormGroup;

                        constructor(private formBuilder: FormBuilder) {}

                        ngOnInit() {
                            this.form = this.formBuilder.group({});
                        }
                    }
                `
            }
        }
    }
};
